<template>
  <WidgetPanel v-if="success">
    <template #header>
      <div class="flex justify-between">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Podcast-Strategie
        </h3>
        <button @click="onEdit">
          <PencilSquareIcon class="flex-shrink-0 h-5 w-5 text-gray-400" />
        </button>
      </div>
    </template>
    <template #default>
      <div class="w-full bg-white divide-y divide-slate-200">
        <Disclosure v-slot="{ open }" as="div" >
          <DisclosureButton class="disclosure-button">
            <span>
              Thematik
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.subject ?? 'Worum geht es in deinem Podcast? Und worum nicht?' }}
          </DisclosurePanel>
        </Disclosure>
        <Disclosure v-slot="{ open }" as="div" class="disclosure" >
          <DisclosureButton class="disclosure-button">
            <span>
              Audience
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.audience ?? 'Wen möchtest du erreichen? Wofür interessieren sich potentielle Hörer*innen?' }}
          </DisclosurePanel>
        </Disclosure>
        <Disclosure v-slot="{ open }" as="div" class="disclosure" >
          <DisclosureButton class="disclosure-button">
            <span>
              USP
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.uniqueness ?? 'Was ist einzigartig an deinem Format? Wofür schaltet man ein?' }}
          </DisclosurePanel>
        </Disclosure>
        <Disclosure v-slot="{ open }" as="div" class="disclosure" >
          <DisclosureButton class="disclosure-button">
            <span>
              Rückenwind
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.tailwind ?? 'Welcher Trend spielt dir in die Karten? Welchen unfairen Vorteil bringst du mit?' }}
          </DisclosurePanel>
        </Disclosure>
        <Disclosure v-slot="{ open }" as="div" class="disclosure" >
          <DisclosureButton class="disclosure-button">
            <span>
              Transformation
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.motivation ?? 'Löst dein Format eine Weiterentwicklung bei Hörenden aus?' }}
          </DisclosurePanel>
        </Disclosure>
        <Disclosure v-slot="{ open }" as="div" class="disclosure" >
          <DisclosureButton class="disclosure-button">
            <span>
              Empfehlbarkeit
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.referability ?? 'Warum wird deine Audience das Format oder Folgen gerne teilen?' }}
          </DisclosurePanel>
        </Disclosure>
        <Disclosure v-slot="{ open }" as="div" class="disclosure" >
          <DisclosureButton class="disclosure-button">
            <span>
              Aufwände
            </span>
            <ChevronUpIcon20 :class="{'button-open': !open}" class="button-icon"/>
          </DisclosureButton>
          <DisclosurePanel class="disclosure-panel">
            {{ resource.expenditure ?? 'Wer kann wie viel Zeit einbringen und sich worum kümmern?' }}
          </DisclosurePanel>
        </Disclosure>
      </div>
    </template>
  </WidgetPanel>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { ChevronUpIcon as ChevronUpIcon20 } from '@heroicons/vue/20/solid';
import { ChevronDownIcon as ChevronDownIcon20 } from '@heroicons/vue/20/solid';
import { useRouter } from 'vue-router';
import { useRetrieveResource } from '@/client/actions';

const props = defineProps({podcast: Object});
const router = useRouter();

const parent = computed(() => props.podcast.id);
const target = computed(() => '/api/podcasts/' + parent.value + '/strategy');
const action = useRetrieveResource(target);

const { retrieve, retrieving, resource, success } = action;

const mounted = onMounted(() => retrieve());
const watcher = watch(target, (v, _) => retrieve());

const onEdit = () => router.push({name: 'podcast.edit.strategy'});
</script>

<style scoped>
.disclosure-panel
{
  @apply px-4 pt-4 pb-4;
  @apply text-sm text-gray-500;
  @apply border-t border-gray-200 ;
};

.disclosure-button
{
  @apply flex w-full justify-between;
  @apply px-4 py-2;
  @apply text-left text-sm text-gray-900;
  @apply font-medium;
  @apply hover:bg-gray-50;
};

.button-icon
{
 @apply h-5 w-5;
 @apply text-gray-500;
};

.button-open
{
  @apply rotate-180;
  @apply transform;
};
</style>

